var map = {
	"./404.svg": 947,
	"./Categories.png": 948,
	"./Edit-menu.svg": 949,
	"./Egg.svg": 950,
	"./Emaier-Header.png": 951,
	"./Qr-4.png": 952,
	"./_duplicate.svg": 953,
	"./_overview.svg": 954,
	"./add-white.svg": 955,
	"./alert.svg": 956,
	"./all_category.svg": 957,
	"./archive.svg": 958,
	"./armchair.svg": 959,
	"./arrow-circle-right.svg": 960,
	"./arrow-left-circle.svg": 961,
	"./arrow-right-circle.svg": 962,
	"./arrow-right.svg": 963,
	"./asc-up-white.svg": 964,
	"./asc.png": 965,
	"./asc.svg": 966,
	"./back-arrow.svg": 967,
	"./barcode-icon.svg": 968,
	"./beverages.svg": 969,
	"./blue-edit-pen.svg": 970,
	"./blue-eye.svg": 971,
	"./box-office.svg": 972,
	"./broken-seat.jpg": 973,
	"./calendar_list.svg": 974,
	"./calender.svg": 358,
	"./chevron-down.svg": 975,
	"./chevron-left.svg": 976,
	"./cinema-mamagement-sidebar.svg": 977,
	"./claendar.svg": 308,
	"./clock-1.svg": 978,
	"./clock.svg": 979,
	"./close-button.svg": 707,
	"./close-white.svg": 710,
	"./close-x.svg": 301,
	"./collapse-up.svg": 980,
	"./collapse.svg": 981,
	"./connection-lost.svg": 356,
	"./copy.svg": 982,
	"./copy_image_icon.png": 983,
	"./delete-red-light.svg": 984,
	"./delete-red.svg": 716,
	"./delete.svg": 692,
	"./deliver-icon.svg": 985,
	"./desc-down-white.svg": 986,
	"./desc.svg": 987,
	"./distributors-sidebar.svg": 988,
	"./download.svg": 989,
	"./dragndrop.svg": 990,
	"./dragndrop2.svg": 991,
	"./duplicate.svg": 992,
	"./duplicateScreen.svg": 993,
	"./e-wallet-icon-black.svg": 994,
	"./edit-pen-blue.svg": 995,
	"./edit-pen-white.svg": 996,
	"./edit-pen.svg": 997,
	"./edit.svg": 998,
	"./email.png": 999,
	"./empty-image.svg": 1000,
	"./excel.svg": 1001,
	"./external-link.svg": 1002,
	"./eye.svg": 1003,
	"./filter-icon.svg": 1004,
	"./flag.svg": 1005,
	"./fnb-app-order.svg": 1006,
	"./fnb-beverages.svg": 1007,
	"./fnb-brownie.svg": 1008,
	"./fnb-combo.svg": 1009,
	"./fnb-desert.svg": 1010,
	"./fnb-eatables.svg": 1011,
	"./fnb-make-your-combo.svg": 1012,
	"./fnb-popcorn.svg": 1013,
	"./fnbtransactionIcon.svg": 1014,
	"./fullscreen-icon.svg": 717,
	"./funnel.svg": 1015,
	"./globe.svg": 1016,
	"./green-tick.svg": 1017,
	"./grid-view.svg": 1018,
	"./hide-password.svg": 359,
	"./home-icon.svg": 1019,
	"./home.svg": 1020,
	"./icon-black-play.svg": 1021,
	"./icon-dot.svg": 1022,
	"./icon-fnb.svg": 1023,
	"./icon-marketing.svg": 1024,
	"./icon-no-seat.png": 1025,
	"./icon-no-seat.svg": 1026,
	"./icon-option.svg": 1027,
	"./icon-poin-of-sale.svg": 1028,
	"./icon-recliner.svg": 1029,
	"./icon-report.svg": 1030,
	"./icon-sofa-dark-1.svg": 1031,
	"./icon-sofa-dark.png": 1032,
	"./icon-sofa-dark.svg": 1033,
	"./icon-sofa.svg": 1034,
	"./importfile.svg": 1035,
	"./info.svg": 711,
	"./info2.svg": 1036,
	"./keyboard-icon.svg": 1037,
	"./kitchen_display.svg": 1038,
	"./language-icon.svg": 302,
	"./left-caret.svg": 1039,
	"./link.svg": 1040,
	"./list-view.svg": 1041,
	"./loading.svg": 360,
	"./lock.svg": 1042,
	"./login-password.png": 361,
	"./login-user.png": 362,
	"./logout.svg": 712,
	"./masters-sidebar.svg": 1043,
	"./merchandise.svg": 1044,
	"./minus.svg": 1045,
	"./movie-pass-svg.svg": 701,
	"./movie-rolling.svg": 1046,
	"./mulitSchedule.svg": 1047,
	"./multicurrency.svg": 1048,
	"./multifnb.svg": 1049,
	"./nav-plus.svg": 1050,
	"./new_filter_icon.svg": 1051,
	"./no-image.svg": 1052,
	"./no-schedule.svg": 134,
	"./non-veg-mark.png": 1053,
	"./non-veg-mark.svg": 1054,
	"./notification.svg": 1055,
	"./open-link-blue.svg": 1056,
	"./openPlanned.svg": 1057,
	"./overview.svg": 1058,
	"./overview2.svg": 1059,
	"./pdf-icon.svg": 1060,
	"./pdf.svg": 1061,
	"./pickup-ticket-icon.svg": 1062,
	"./pickupfnb.svg": 1063,
	"./play.svg": 1064,
	"./plus.svg": 1065,
	"./pointofsale-1.svg": 1066,
	"./pointofsale-2.svg": 1067,
	"./pointofsale.png": 1068,
	"./portfolio.svg": 1069,
	"./pos-fnb-no-itmes.svg": 703,
	"./pos-refresh.svg": 1070,
	"./primary/chevron-down.svg": 1071,
	"./primary/download.svg": 1072,
	"./primary/edit.svg": 1073,
	"./primary/filter.svg": 1074,
	"./primary/printer.svg": 1075,
	"./print-icon.svg": 1076,
	"./print.svg": 1077,
	"./question.svg": 1078,
	"./question1.svg": 1079,
	"./question2.svg": 718,
	"./question3.svg": 1080,
	"./recliner-1.svg": 1081,
	"./recliner.png": 1082,
	"./refund-icon.svg": 1083,
	"./reload-icon-pos.svg": 1084,
	"./reload-icon.svg": 1085,
	"./restore.svg": 1086,
	"./right-caret.svg": 1087,
	"./role-management-sidebar.svg": 1088,
	"./save.svg": 1089,
	"./schedule-icon.svg": 1090,
	"./school-calendar.svg": 1091,
	"./search-global-white.svg": 1092,
	"./search-global.svg": 1093,
	"./search.svg": 719,
	"./searchIcon.svg": 1094,
	"./seat-icon-2.svg": 1095,
	"./seat-icon.svg": 1096,
	"./seat-icons/3-wheelChair.png": 1097,
	"./seat-icons/block_seat_new.png": 1098,
	"./seat-icons/broken-seat-1.svg": 1099,
	"./seat-icons/broken-seat-2.svg": 1100,
	"./select-food.png": 720,
	"./settings.svg": 1101,
	"./show-password.svg": 363,
	"./slider-triangle.svg": 1102,
	"./snack.svg": 713,
	"./sort.svg": 1103,
	"./star-empty.svg": 1104,
	"./star-fill.svg": 1105,
	"./success-tick.svg": 1106,
	"./suitcase.svg": 1107,
	"./swap.svg": 1108,
	"./tick-green-item.svg": 721,
	"./tick-green.svg": 1109,
	"./ticket-icon.svg": 1110,
	"./trash.svg": 1111,
	"./unpaid-reservation.svg": 695,
	"./updown-white.svg": 1112,
	"./updown.svg": 1113,
	"./user-attribute.svg": 1114,
	"./user-attributes.svg": 1115,
	"./user-female.svg": 1116,
	"./user-male-white.svg": 1117,
	"./user-male.svg": 1118,
	"./user-profile.svg": 1119,
	"./userProfile.png": 1120,
	"./veg-food-mark-white.png": 1121,
	"./veg-foog-mark-trans.png": 1122,
	"./view.png": 1123,
	"./view.svg": 1124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 946;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 946
// module chunks = 35